import { defineMessages } from 'react-intl';

export default defineMessages({
    titleError: {
        id: 'Select your title',
        defaultMessage: 'Select your title'
    },
    firstNameError: {
        id: 'Enter your first name',
        defaultMessage: 'Enter your first name'
    },
    lastNameError: {
        id: 'Enter your last name',
        defaultMessage: 'Enter your last name'
    },
    validDateError: {
        id: 'Please enter a valid date',
        defaultMessage: 'Please enter a valid date'
    },
    mainContactError: {
        id: 'Please enter your main contact number',
        defaultMessage: 'Please enter your main contact number'
    },
    validMainPhoneError: {
        id: '_.errors.invalid_main_german_phone_number',
        defaultMessage: 'Please enter a valid contact number'
    },
    noPostcodeError: {
        id: 'Please enter a valid postcode',
        defaultMessage: 'Please enter a postcode'
    },
    validPostcodeError: {
        id: '_.error.address.postcode',
        defaultMessage: 'Please enter a valid postcode'
    },
    townError: {
        id: 'Enter your town',
        defaultMessage: 'Enter your town'
    },
    houseNumberError: {
        id: 'Enter house number',
        defaultMessage: 'Enter house number'
    },
    streetNameError: {
        id: 'Enter street name',
        defaultMessage: 'Enter street name'
    }
});
